import Component from 'vue-class-component';
import {EmailSearchResult, UserApiService} from '@/services/generated/edge/user';
import StatusEnum = EmailSearchResult.StatusEnum;
import {RegistrationVue} from '@/registration-vue';
import './email-entry.scss';
declare var dataLayer: any;
@Component({template: require('./email-entry.html')})
export class EmailEntryPage extends RegistrationVue {

  loading: boolean = false;

  mounted() {
    dataLayer.push({
      'event': 'stepLoaded',
      'stepNumber': '1',
      'stepName': 'Enter email address'
    });
    this.$validator.updateDictionary({
      en: {
        custom: {
          email: {
            required: 'Please enter your email address',
            email: 'That email doesn\'t look right'
          }
        }
      }
    });
  }

  next() {
    this.doIfFormIsValid(() => {
      this.loading = true;
      UserApiService.findUserByEmail({
        email: this.$store.state.email,
        banner: ''
      }).then((searchResult: EmailSearchResult) => {

        this.$store.state.firstName = searchResult.firstName;
        this.$store.state.lastName = searchResult.lastName;

        switch (searchResult.status) {
          case StatusEnum.REGISTERED:
            this.navigate('email-registered');
            break;
          case StatusEnum.PARTIAL_REGISTERED:
            this.$store.state.isQuickShopper = false;

            // club card takes priority over fresh mailer list
            if (searchResult.roles.includes('ZNW001')) {
              this.navigate('clubcard-verify');
              break;
            } else if (searchResult.roles.includes('ZNW002')) {
              // fresh mailing list role
              this.navigate('fresh-registration');
              break;
            } else {
              // partially registered users with neither role still go to fresh registration page
              this.navigate('fresh-registration');
              break;
            }
          case StatusEnum.NOT_REGISTERED:
            this.navigate('clubcard-has-question');
            break;
          default:
            this.loading = false;
            this.handleApiError(`Unknown status: ${searchResult.status}`);
            break;
        }
      }).catch((error) => {
        this.loading = false;
        this.handleApiError(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/forms/email-entry/email-entry.ts